export const scoreIconDataFields = [
  'SourceScore',
  'DestinationScore',
  'LowestScore',
  'annuityWizardScoreClass',
  'investmentWizardScoreClass',
  'lifeWizardScoreClass',
  'productProfilerScoreClass',
  'destinationProductScoreClass',
  'sourceOfFundScoreClass',
  'fundScoreClass',
  'portfolioScoreClass',
  'programScoreClass',
  'destinationProductScoreClass',
  'sourceOfFundScoreClass',
  'destinationProductScoreClass',
  'sourceOfFundScoreClass',
  'scoreClass',
  'ScoreClass',
];

export const noColSaveGrids = ['CaseSearch', 'RepBehavior', 'IWProductShelf'];

export const noFilterSaveGrids = [
  'CaseSearch',
  'RepBehavior',
  'IWProductShelf',
];

export const ptGrids = [
  'AmlMonitorGrid',
  'RepReviewGrid',
  'AccountReviewGrid',
  'TradeReviewGrid',
  'AccountLinkingGrid',
];

export const bulkActionOptions = [
  { display: 'Approve', value: 'approve' },
  { display: 'Reject', value: 'reject' },
  { display: 'Mark In Process', value: 'inProcess' },
  { display: 'Reopen', value: 'reopen' },
];

export const pageSizeOptions = [25, 50, 75, 100, 500];

export const appCols = [
  'productProfilerProducts',
  'productProfilerScoreClass',
  'annuityWizardProducts',
  'annuityWizardScoreClass',
  'investmentWizardProducts',
  'investmentWizardScoreClass',
  'lifeWizardProducts',
  'lifeWizardScoreClass',
];

const gridSortText = {
  string: {
    asc: 'Sort A → Z',
    desc: 'Sort Z → A',
  },
  date: {
    asc: 'Sort Old → New',
    desc: 'Sort New → Old',
  },
  numeric: {
    asc: 'Sort Low → High',
    desc: 'Sort High → Low',
  },
  default: {
    asc: 'Sort Ascending',
    desc: 'Sort Descending',
  },
};

const numericTypes = [
  'perc',
  'perc2',
  'perc3',
  'double',
  'curr',
  'integer',
  'num',
];

export const getFilterMenuText = function (columnType, sortDirection) {
  if (gridSortText[columnType]) {
    return gridSortText[columnType][sortDirection];
  }
  if (numericTypes.includes(columnType)) {
    return gridSortText['numeric'][sortDirection];
  }
  return gridSortText['default'][sortDirection];
};

export const presetDateValues = [
  'mtd',
  'ytd',
  '12mtd',
  '7 days',
  '30 days',
  '90 days',
  'custom',
];
